export default __webpack_public_path__ + "static/media/Gemini.00107536.svg";